<div class="vbm-comment-section">
    <div class="vbm-comment-box" >
      <a href="javascript:void(0);" class="vbm-left-image cursor-default">
        <img src="{{UserThumbnail}}" alt="{{bs.getResource('rbkey_CmmntUsrImgLBL')}}">
      </a>
      <div class="vbm-right-comment-box">
        <textarea maxlength="250" name="" id="txtAdd{{TileId}}" rows="1" class="comment-input" placeholder="{{bs.getResource('rbkey_CnvrstnCmmntPlcHldrLBL')}}"></textarea>
        <div *ngIf="ValidationMsg">
        </div>
        <a href="javascript:void(0);" class="submit-button" id="btnAdd{{TileId}}" (click)="AddComment(TileId,bs.getUserAttr('UserId'))">{{bs.getResource('rbkey_AvlablChnnlSbmtLBL')}}</a>
        <div class="arrow-left"></div>
      </div>
    </div>
    <div class="vbm-comment-box" *ngFor="let item of CommentList;let i = index">
      <div >
        <div class="vbm-comment-box" id="Thread{{item['ConversationId']}}" *ngIf="item['IsEditable']" style="display:none;">
          <a href="javascript:void(0);" class="vbm-left-image cursor-default">
            <img src="{{item['UserThumbnail']}}" alt="{{bs.getResource('rbkey_CmmntUsrImgLBL')}}">
          </a>
          <div class="vbm-right-comment-box">
            <textarea name="" maxlength="250" id="Text{{item['ConversationId']}}" rows="1" class="comment-input" placeholder="{{bs.getResource('rbkey_CnvrstnCmmntPlcHldrLBL')}}"></textarea>
            <div style="display:none" id="CmtValdiation{{item['ConversationId']}}">
            </div>
            <a href="javascript:void(0);" (click)="EditComment(item['TileId'],item['ConversationId'],i)" class="submit-button">{{bs.getResource('rbkey_AvlablChnnlSbmtLBL')}}</a>
            <div class="arrow-left"></div>
          </div>
        </div>
      </div>
      <a href="javascript:void(0);" class="vbm-left-image cursor-default" *ngIf="item['ConversationText']!=''">
        <img src="{{item['UserThumbnail']}}" alt="{{bs.getResource('rbkey_CmmntUsrImgLBL')}}">
      </a>
      <div class="vbm-right-comment-box" id="Comment{{item['ConversationId']}}" *ngIf="item['ConversationText']!=''">
        <div class="right-comment-box-details">
          <div class="cb-top">
            <div class="cbt-name">
              <a class="name-link" href="javascript:void(0);" style="cursor:default">{{item['UserName']}}</a>
              <!-- <span class="cbt-post">{{item.JobRole}}</span> -->
            </div>
            <div class="vbm-right-menu">
              <a href="javascript:void(0);" data-toggle="dropdown" class="dropdown-toggle vlb-menu" title="{{bs.getResource('rbkey_ActnLBL')}}"></a>
              <ul role="menu" class="dropdown-menu animated fadeIn right">
                <li *ngIf="item['IsEditable']" >
                  <a href="#" (click)="EditElements(item['ConversationId'])">{{bs.getResource('rbkey_CnvrstnCmmntEdtBTN')}}</a>
                </li>
                <li *ngIf="item['IsEditable']" >
                  <a href="#" (click)="DeleteComment(i,item['ConversationId'],item['TileId'],item['UserId'])">{{bs.getResource('rbkey_CnvrstnCmmntDltBTN')}}</a>
                </li>
                <li *ngIf="!item['IsEditable']">
                  <a href="javascript:void(0);" (click)="ReportAbuseConversation(item,i)">{{bs.getResource('rbkey_RprtAbsCmmntLBL')}}</a>
                </li>
              </ul>
            </div>
  
           
            <a href="javascript:void(0)" *ngIf="item['UserId'] != bs.getUserAttr('UserId')" class="report-abuse-cbt" title="{{bs.getResource('rbkey_RprtAbsCmmntLBL')}}" [ngClass]="{'no-cursor':  item['UserId'] == bs.getUserAttr('UserId') }"> <i id="ReportAbuse{{item['ConversationId']}}" [ngClass]="{'fa-flag-red':  item['IsReportedAbuse']==true }"  class=" fa fa-flag"></i></a>           
            <a href="javascript:void(0);"  (click)="LikeConversation(item,i)"  class="likes-cbt" title="{{bs.getResource('rbkey_LksLBL')}}" [ngClass]="{'no-cursor':  item['UserId'] == bs.getUserAttr('UserId') }"><i id="Like{{item['ConversationId']}}" [ngClass]="{'fa-thumbs-up-blue':  item['IsLiked']==true }" class="fa fa-thumbs-up"></i><span class="reviews">{{item['LikeCount']}}</span></a>
            <div class="days-text">{{item['PostedDuration'] | lowercase}}</div>
           
            
            
          </div>
          <div class="cb-details-text">
            <span id="ConversationText{{item['ConversationId']}}">{{item.ConversationText}}</span>
          </div>
        </div>
        <div class="arrow-left"></div>
      </div>
    </div>
    <div *ngIf="ShowButton">
      <div *ngIf="NumberOfComments>0">
        <a href="javascript:void(0);" class="show-more-comments" (click)="showMoreComments(TileId,ConversationId,bs.getUserAttr('UserId'))">{{bs.getResource('rbkey_ShwMrLBL')}}</a>
      </div>
    </div>
    <div *ngIf="ShowLessButton">
        <a href="javascript:void(0);" class="show-more-comments" (click)="showLessComments()">{{bs.getResource('rbkey_ShwLssLBL')}}</a>
      </div>
  </div>
  
